import { RadioGroup } from '@headlessui/react';
import { useField } from 'formik';
import React from 'react';
import Tooltip from '../../Tooltip';
import classNames from '../../../utility/classNames';

export default function RadioButtons({
  name,
  label,
  options,
  touched,
  error,
  description,
}) {
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  return (
    <div className="mt-6 sm:mt-5 space-y-6 sm:space-y-5">
      <div className="sm:grid sm:grid-cols-3-inputs sm:gap-4 sm:items-center text-md font-medium">
        <label
          className="block text-md font-normal text-neutral-900 "
          htmlFor="radiobutton"
        >
          {label} {description && <Tooltip text={description} type="info" />}
        </label>
        <RadioGroup
          value={field.value}
          onChange={setValue}
          id="radiobutton"
          className="sm:col-span-2 py-2 flex justify-stretch"
        >
          <RadioGroup.Label className="sr-only">{label}</RadioGroup.Label>
          <div
            className={`flex flex-col sm:flex-row gap-3 col-span-2 w-full justify-stretch`}
          >
            {options.map((option) => (
              <RadioGroup.Option
                key={option.value}
                value={option.value}
                className={({ checked }) =>
                  classNames(
                    'min-h-8 rounded-full flex justify-center items-center px-4 py-[6px]',
                    checked
                      ? 'bg-primary-500 text-white border-2 border-primary-500 '
                      : 'bg-white text-neutral-500 border-2 border-neutral-500 hover:border-neutral-900 focus:border-neutral-900'
                  )
                }
              >
                <RadioGroup.Label as="p">{option.label}</RadioGroup.Label>
              </RadioGroup.Option>
            ))}
          </div>
        </RadioGroup>
        {touched && error ? (
          <div className="error text-base text-warning ">{error}</div>
        ) : null}
      </div>
    </div>
  );
}
